import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '../api/v1/http.service'

const responseSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    url: z.string()
  })
)

const useFavourites = () =>
  useQuery({
    queryKey: ['savedLinks'],
    staleTime: 60 * 100,
    queryFn: async () => {
      const response = await httpService.panel.panelUsersSavedLinksList({
        page_size: 'max'
      })
      return responseSchema.parse(response.results)
    }
  })

export default useFavourites
